import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { ChannelMetaDataCustom } from '../../types';
import { getErrorText } from '../helpers';

export const getAllowedToSpeakList = createAsyncThunk<
  Pubnub.GetChannelMetadataResponse<ChannelMetaDataCustom>,
  { roomId: string },
  { rejectValue: string }
>('pubnub/getAllowedToSpeakList', async (data, { rejectWithValue, getState }) => {
  try {
    const pubnubReducer = (getState() as RootState).pubnub;

    if (pubnubReducer.pubnub) {
      const result: Pubnub.GetChannelMetadataResponse<ChannelMetaDataCustom> =
        await pubnubReducer.pubnub.objects.getChannelMetadata({
          channel: data.roomId,
        });

      return result;
    } else {
      throw new Error('PubnubInstanceIsNull');
    }
  } catch (e) {
    return rejectWithValue(getErrorText(e as Error));
  }
});
